// extracted by mini-css-extract-plugin
export const layout = "information-module--layout--3RV3A";
export const title = "information-module--title--23eiM";
export const text = "information-module--text--1Ealx";